import type { EventIncidentType, EventType } from "app/types/eventType";
import AsianEventScore from "../../components/AsianEventScore/AsianEventScore";
import AsianEventScoreExtraTime from "../../components/AsianEventScoreExtraTime/AsianEventScoreExtraTime";
export class DisplayStateScores {
  static displayStateScores(
    event: EventType,
    eventIncidents: EventIncidentType[],
    period: string
  ): any | string {
    const scoreFullTime =
      period === "fullTime" ? (
        <div className="asian-event__score">
          <AsianEventScore
            event={event}
            eventIncidents={eventIncidents}
            period={period}
          />
        </div>
      ) : (
        <AsianEventScoreExtraTime
          event={event}
          eventIncidents={eventIncidents}
          period={period}
        />
      );
    return scoreFullTime;
  }
}
